export function   getDateHelper(date, type?: string) {
  const today = new Date(date);
  let dd: any = today.getDate();
  let mm: any = today.getMonth() + 1;
  const yyyy = today.getFullYear();
  if (dd < 10) {
    dd = '0' + dd;
  }
  if (mm < 10) {
    mm = '0' + mm;
  }
  if (type && type === 'start') {
    return dd + '-' + mm + '-' + yyyy + ' ' + '00:00:00' ;
  }
  return dd + '-' + mm + '-' + yyyy + ' ' + '23:59:59';
}
